export default {"src":"/_next/static/media/bathroom-heater.e6a3237c.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};